import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import styles from './style.module.scss';
import { textFooterEnv } from '../../utils/utils';
import { useSelector } from 'react-redux';


function BottomNav9() {
  const envInfoList = useSelector((state) => state.envInfo.data);

  const textFooter = () => {
    return textFooterEnv(envInfoList ?? []);
  };

  return (
    <AppBar className={[styles.app__bar, 'iframe-trigger-preview']} position="fixed" style={{ backgroundColor: 'white' }}>
      <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
        <p style={{ color: 'var(--text3)' }} className="font-3" dangerouslySetInnerHTML={{ __html: textFooter() }}></p>
      </div>
    </AppBar>
  );
}

export default BottomNav9;
